// Importación de React y los componentes que conforman la página de inicio.
import React from "react";
import Banner from "../component/Banner"; // Componente del banner principal.
import Empresa from "../component/Empresa"; // Componente con información de la empresa.
import Propuesta from "../component/Propuesta"; // Componente que describe la propuesta de valor.
import Alianzas from "../component/Alianzas"; // Componente que muestra las alianzas.
import Faq from "../component/Faq"; // Componente de preguntas frecuentes.
import VideoPlayer from "../component/VideoPlayer"; // Componente para reproducir un video.
import Calendario from "../component/Calendario"; // Componente con el calendario de eventos.
import '../component/stylevideo.css'; // Importa estilos específicos para el componente de video.

// Componentes que actualmente no se están utilizando en esta página.
// import Navbar from "../component/Navbar";
// import Certificados from "../component/Certificados";
// import Clientes from "../component/Clientes";

/**
 * Componente de la página de inicio (Home).
 * Este componente actúa como un contenedor que organiza y renderiza 
 * los distintos bloques de contenido que componen la página principal.
 */
export const Home = () => {
  return (
    // Contenedor principal de la página.
    <div className="">
      {/* Renderiza el componente del banner principal en la parte superior. */}
      <Banner />
      
      {/* Renderiza la sección que presenta a la empresa. */}
      <Empresa />
      
      {/* Renderiza la sección de la propuesta de valor. */}
      <Propuesta />
      
      {/* Contenedor para la sección del calendario. */}
      {/* El 'id="calendario"' permite la navegación directa a esta sección (ej. desde el Navbar). */}
      <div id="calendario">
        <h2 className="text-center text-4xl font-bold mt-10">Calendario de Eventos</h2>
        <Calendario />
      </div>
      
      {/* Renderiza el reproductor de video. */}
      <VideoPlayer />
      
      {/* Renderiza la sección de alianzas estratégicas. */}
      <Alianzas />
      
      {/* Renderiza la sección de preguntas frecuentes. */}
      <Faq />
      
      {/* Los siguientes componentes están comentados y no se mostrarán en la página. */}
      {/* <Certificados/> */}
      {/* <Clientes/> */}
    </div>
  );
};

// Exporta el componente Home para ser utilizado por el enrutador de la aplicación.
export default Home;